const intervals = {
  day: 'daily',
  month: 'monthly',
  fortnight: 'fortnightly',
  year: 'yearly'
};

export default intervals;



// WEBPACK FOOTER //
// ./src/constants/intervals.js